import React from 'react';
import './TargetLanding.css';
import image2 from "../../assets/pikachu3.png";
import image1 from "../../assets/pikachu.png";
import Contact from '../contact/Contact'; // ✅ adjust path as needed

const TargetLanding = () => {
  return (
    <main className="target-landing section">
      <div className="container">
        <h1 className="section__title">Designed Pikachu Game Website</h1>

        <div className='target-image-container'>
          <img className="target-image" src={image1} alt="Pikachu Game Main Screen" />
        </div>
        <p>For the Pikachu game download website, I designed a vibrant and engaging landing page that reflects the fun and energy of the game while ensuring an intuitive user experience. The design focuses on driving downloads, presenting the game’s features, and creating a seamless process for visitors to get started with the game.</p>

        <h3>1. Visual Design Concept</h3>

        <p>The website was designed with the playful and dynamic world of Pikachu in mind. I used bright, eye-catching colors like yellow, red, and green to capture the fun, cheerful nature of the game. The layout balances engaging visuals with user-friendly navigation, ensuring that users can easily find what they need without feeling overwhelmed.</p>

        <div className='target-image-container'>
          <img className="target-image" src={image2} alt="Target App Wireframe" />
        </div>

        <p>This wireframe was designed in <strong>Figma</strong> to lay the groundwork for a clean, user-friendly interface.</p>

        <h3>2. Design Tools Used:</h3>
        <ul className="target-features">
          <li><strong>Figma:</strong> For wireframing, prototyping, and creating high-fidelity designs that are both responsive and visually stunning.</li>
          <li><strong>Adobe Photoshop:</strong> For editing images, creating custom graphics, and enhancing visual elements like icons and buttons.</li>
        </ul>

        {/* Embedded YouTube Video */}
        <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/9s53Gh1nmNk?si=gayP5GQ7bc6tRKux"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{ maxWidth: '800px', borderRadius: '10px' }}
          ></iframe>
        </div>

        <h3>Why This Design Works:</h3>
        <ul className="target-features">
          <li><strong>Fun and Playful Visuals:</strong> The design matches the energetic and exciting nature of the Pikachu game, creating an immediate connection with the target audience.</li>
          <li><strong>Clear and Simple Navigation:</strong> Users can easily access the download link and information about the game, improving the chances of conversion.</li>
          <li><strong>Engagement Focused:</strong> By including gameplay previews, user reviews, and direct download links, the website actively encourages users to interact and engage with the content.</li>
        </ul>

        <p>This Pikachu game download website is designed to not only capture the essence of the game but also provide a smooth, enjoyable experience that encourages users to start their journey with Pikachu right away!</p>

        {/* Embedded Figma Prototype – Pikachu Game Website */}
        <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
          <iframe
            src="https://embed.figma.com/design/A3N4tmyCprNffloTPNayTY/Pikachu-game-website?node-id=0-1&embed-host=share"
            title="Pikachu Game Website Design"
            width="100%"
            height="450"
            allowFullScreen
            style={{
              maxWidth: '800px',
              border: '1px solid rgba(0, 0, 0, 0.1)',
              borderRadius: '10px'
            }}
          ></iframe>
        </div>


        <section className="target-cta">
          <h2>Hire Me to Elevate Your Brand</h2>
          <p>
            If you're looking to transform your website and create designs that leave a lasting impression, I'm here to deliver exceptional results.
          </p>
        </section>

        {/* ✅ Contact Form Directly Rendered Below */}
        <div style={{ marginTop: '40px' }}>
          <Contact />
        </div>
      </div>
    </main>
  );
};

export default TargetLanding;
